// Ported from TableFlow csv-import (https://github.com/tableflowhq/csv-import),
// src/importer/utils/stringSimilarity.ts. MIT License, Copyright (c) 2023 Portola Labs, Inc.
// The full licence text is in `packages/import-mapping/LICENSE-TableFlow`.
//
// The edit distance comes from https://stackoverflow.com/a/36566052, as in the original.
//
// Changes made by Lafayette:
// - A named export instead of the default export.
// - Types fixed for `noUncheckedIndexedAccess` and `exactOptionalPropertyTypes`; no behaviour change.
// - TableFlow auto-selected a column when the score was above 0.9. Lafayette does NOT: a similar
//   header is only a MEDIUM suggestion, and staff must accept it (see `suggest.ts`).
/** The best similarity between any word of `s1` and any word of `s2`, from 0 to 1. */
export function stringsSimilarity(s1, s2) {
    const words = s1.split(" ");
    const words2 = s2.split(" ");
    let highest = 0;
    for (const word of words) {
        for (const word2 of words2) {
            const wordSimilarity = similarity(word, word2);
            if (wordSimilarity > highest)
                highest = wordSimilarity;
        }
    }
    return highest;
}
function similarity(s1, s2) {
    let longer = s1;
    let shorter = s2;
    if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
    }
    const longerLength = longer.length;
    if (longerLength === 0)
        return 1.0;
    return (longerLength - editDistance(longer, shorter)) / longerLength;
}
function editDistance(a, b) {
    const s1 = a.toLowerCase();
    const s2 = b.toLowerCase();
    const costs = new Array(s2.length + 1).fill(0);
    for (let i = 0; i <= s1.length; i++) {
        let lastValue = i;
        for (let j = 0; j <= s2.length; j++) {
            if (i === 0) {
                costs[j] = j;
            }
            else if (j > 0) {
                let newValue = costs[j - 1] ?? 0;
                if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
                    newValue = Math.min(Math.min(newValue, lastValue), costs[j] ?? 0) + 1;
                }
                costs[j - 1] = lastValue;
                lastValue = newValue;
            }
        }
        if (i > 0)
            costs[s2.length] = lastValue;
    }
    return costs[s2.length] ?? 0;
}
